import React from 'react';

import { observer } from 'mobx-react-lite';

import { forageGet, forageSet } from 'utils/misc';

import { UuidType } from 'utils/types';
//import useUserIdentity from 'hooks/useUserIdentity';
export type StoredOrderType = {
    slug: string,
    sorted: string[], // The sorted uuids
    date: string,
};


type SortableContextType = {

    // createSortable: (identity: string, associated_type: string, associated_uuid: string) => Promise<SortableType>;

    // Fetch and get one
    fetchSortable: (slug: string) => Promise<StoredOrderType | null>;
    //    getSortable: (identity: string) => SortableType | null;

    getSortable: (slug: string) => string[];
    setSortable: (slug: string, order: string[]) => void;
    getSorted: (slug: string, things: UuidType[]) => UuidType[];
    sortableItems: StoredOrderType[];
}

export const SortableContext = React.createContext<SortableContextType>({
    // createSortable: () => { throw 'Not Implemented' },
    fetchSortable: () => { throw 'Not Implemented fetchSortable' },
    getSortable: () => { throw 'Not Implemented getSortable' },
    setSortable: () => { throw 'Not Implemented setSortable' },
    getSorted: () => { throw 'Not Implemented getSorted' },
    sortableItems: [],
});




export const SortableProvider = observer(({ children }: { children: React.ReactNode }) => {

    // const { sortableStore } = useStores();
    const [sortableItems, setSortableItems] = React.useState<StoredOrderType[]>([]);
    const [forageGotSlugs, setForageGotSlug] = React.useState<string[]>([]);

    //const { currentIdentity } = useUserIdentity();
    // const fetchSortable = async (uuid: string) => {
    //     return sortableStore.fetchSortable(uuid);
    // };

    const getSortable = (slug: string) => {
        if(!forageGotSlugs.includes(slug)) {
            // console.log("Loading sorted");
            fetchSortable(slug);
        }

        const item = sortableItems.find((item) => item.slug === slug);
        return item ? item.sorted : [];
    };


    function getSorted(slug: string, things: UuidType[]): UuidType[] {
        const order = getSortable(slug);
        function cmp(a: UuidType, b: UuidType) {
            if (order === undefined) return 0;
            var aIndex = order.indexOf(a.uuid);
            var bIndex = order.indexOf(b.uuid);
            aIndex = aIndex === -1 ? Infinity : aIndex;
            bIndex = bIndex === -1 ? Infinity : aIndex;
            return aIndex > bIndex ? -1 : 1;// - order.indexOf(b.uuid);
        }
        const sortedSortableItems = things.sort(cmp).slice();
        // console.log("getSorted: sortedItemd", sortedSortableItems);
        return sortedSortableItems;
    }


    async function fetchSortable(slug: string) {
        // console.log("fetchSortable item order", identity, slug);
        return forageGet<StoredOrderType>(slug)
            .then((storedOrder: StoredOrderType | null) => {
                if (storedOrder) {
                    setSortableItems([storedOrder]);
                    setForageGotSlug([...forageGotSlugs, slug]);
                    return storedOrder;
                }
                return null;
            });
    }

    function setSortable(slug: string, order: string[]) {
        const item = sortableItems.find((item) => item.slug === slug);
        if (item) {
            const updatedItem = { ...item, sorted: order };
            const newItems = sortableItems.map((item) => {
                if (item.slug === slug) {
                    return updatedItem;
                }
                return item;
            });
            // item.sorted = order;
             console.log("found sortableItems, set to", updatedItem.sorted);
            setSortableItems([...newItems]);
            forageSet(slug, updatedItem);
        } else {
            const newItem = {
                slug,
                sorted: order,
                date: new Date().toISOString(),
            };
            setSortableItems([...sortableItems, newItem]);
            console.log("Setting sortableItems to", [newItem, ...sortableItems]);
            forageSet(slug, newItem);
        }
    }

    const data = {
        fetchSortable,
        getSortable,
        setSortable,
        getSorted,
        sortableItems

        // items: sortableStore.items,
    };

    return (
        <SortableContext.Provider value={data}>
            { children }
        </SortableContext.Provider>
    );

});
